import React from 'react';
import {
  StyleSheet, View, ScrollView, Text,
} from 'react-native';
import Colors from '../../../../../constants/Colors';

const PPMSection = () => <ScrollView style={styles.container}>
  <View style={styles.header}>
    <Text style={styles.title}>{'PPM form'}</Text>
  </View>
</ScrollView>;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    marginHorizontal: -16,
  },
  header: {
    padding: 16,
    marginVertical: 16,
    borderWidth: 1,
    borderRadius: 16,
    borderColor: Colors.light.hereworksBlue50,
    backgroundColor: '#FFF',
  },
  title: {
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack600,
  },
});

export default PPMSection;
